import { RootState } from '@src/store/store'
import { PromotionStateType } from '@src/store/ducks/promotion/reducer'

export const selectPromotions = (state: RootState): PromotionStateType => state.promotion
export const selectGameData = (state: RootState) => state.app.dataGamePage
